import * as React from 'react'
import * as styles from './Loader.css'

export function Loader() {
	return (
		<div className={styles.loader}>
			<span className={styles.dot} />
		</div>
	)
}
